import { NotificationSettingService } from '@/modules/global-settings/miscellaneous/services/notification.service';
import { make } from 'vuex-pathify';

// Create a new instance of the NotificationSettingService class
const notificationService = new NotificationSettingService();
// Notification Settings module state
export const state = {
  notificationSettings: []
};
// Notification Settings module mutations
export const mutations = {
  ...make.mutations(state)
};
// Notification Settings module actions
export const actions = {
  /**
   * Fetches all Notification Settings
   * @param {Object} context - Vuex action context
   * @returns {void}
   * @private This sets the Notification Settings in the state
   */
  async getNotificationSettings({ commit }) {
    const result = await notificationService.getNotificationSettings();
    commit('SET_NOTIFICATION_SETTINGS', result.data);
    return result.data;
  },

  /**
   * Creates a Notification Setting
   * @param {Object} context - Vuex action context
   * @param {Object} payload - Notification Setting payload
   * @param {String} payload.id - Notification Setting ID
   * @param {Object} payload.updates - Notification Setting payload
   * @returns {void}
   * @private This will re-fetch the Notification Settings & set them in state
   */
  async updateNotificationSetting({ dispatch }, { id, updates }) {
    const result = await notificationService.updateNotificationSettings(
      id,
      updates
    );
    if (result.status === 200) {
      dispatch('getNotificationSettings');
    }
    return result;
  }
};
